import React, { useState, useEffect } from "react";
import logo from "../assets/images/logo.png";
import { IoClose } from "react-icons/io5";
import { Link, useNavigate } from 'react-router-dom';
import AuthService from "../services/AuthService";
import { toast } from "react-toastify";

const Sidebar = ({ setSidebarOpen }) => {
  const [selectedLang, setSelectedLang] = useState("eng");
  const [isOpen, setIsOpen] = useState(true);
  const [isFullyClosed, setIsFullyClosed] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const authUser = AuthService.getCurrentUser();
  const navigate = useNavigate();

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(() => setSidebarOpen(false), 300);
  };

  // Auto-close sidebar when any link is clicked
  const handleLinkClick = () => {
    handleClose();
  };

  const handleLogout = () => {
    AuthService.logout();
    toast.success("Logged out successfully");
    const basePath= process.env.REACT_APP_BASE_PATH;
    window.location.href= basePath+"/login";
    // navigate("/login");
  };

  // Handle scroll for sticky behavior
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsSticky(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      {!isFullyClosed && (
        <div
          className={`sidebar-main shadow ${isOpen ? "open" : "closed"} ${isSticky ? "sticky" : ""}`}
          onTransitionEnd={() => {
            if (!isOpen) setIsFullyClosed(true);
          }}
        >
          <button className="close-btn" onClick={handleClose}>
            <IoClose size={24} />
          </button>
          <div className="sidebar-img ">
            <Link to={'/'} onClick={handleLinkClick}>
              <img src={logo} />
            </Link>
          </div>
          <span className="d-flex justify-content-center fw-bold fs-5 my-3">
            WING STOP
          </span>
         

          <div className="languages my-3 py-2 d-flex shadow justify-content-center ">
            <p
              className={`lang-option ${
                selectedLang === "eng" ? "selected" : ""
              }`}
              onClick={() => setSelectedLang("eng")}
            >
              English
            </p>
            <p
              className={`lang-option ${
                selectedLang === "arbi" ? "selected" : ""
              }`}
              onClick={() => setSelectedLang("arbi")}
            >
              عربي
            </p>
          </div>
          <div className="links">
            <Link to="/items" onClick={handleLinkClick}>Menu</Link>
            {(authUser && !authUser?.is_guest) ? (
              <>
                <Link to="/account" onClick={handleLinkClick}>My Account</Link>
                <Link to="/my-orders" onClick={handleLinkClick}>My Orders</Link>
                <Link to="/address-list" onClick={handleLinkClick}>My Address</Link>
                <Link to="#" onClick={handleLogout}> Logout</Link>
              </>
            ):(
              <>
                <Link to="/register" onClick={handleLinkClick}>Register</Link>
                <Link to="/login" onClick={handleLinkClick}>Login</Link>
              </>
            )}
            <Link href="#" onClick={handleLinkClick}>Privacy Policy</Link>
          </div>

          <span className="version">Version 1.0</span>
        </div>
      )}
    </>
  );
};

export default Sidebar;
